import netsTutorial from './nets-tutorial';

export default angular
  .module('app.tutorial', [])
  .component('netsTutorial', netsTutorial);
